<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-crud-table [crudService]="crudService"
                [transPartKey]="'user-group'" [fieldId]="'groupName'" [fieldName]="'groupName'" [fieldEnabled]="'enabled'"
                [tableConfig]="tableConfig" [newRecord]="newRecord" [tableLoading]="tableLoading"
                [(formRecord)]="formRecord" [formConfig]="formConfig"
                [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                [prepareForCreate]="prepareRecordForCreate"
                [prepareForEdit]="prepareRecordForEdit" [prepareForClone]="prepareRecordForClone"
                [globalErrorMessage]="globalErrorMessage"
                [globalInfoMessage]="globalInfoMessage"
                [totalRecords]="totalRecords"
                [dialogClass]="'cc-user-form-dialog'"
                [deleteRoles]="CCRoles.ROLES_SECURITY_DELETE"
></app-crud-table>
